interface ServiceFeature {
  title: string
  description: string
}

interface ServicePageLayoutProps {
  title: string
  subtitle: string
  description: string
  benefits: string[]
  features: ServiceFeature[]
  videoEmbedId: string
}

const ServicePageLayout = ({
  title,
  subtitle: _subtitle,
  description,
  benefits,
  features,
  videoEmbedId
}: ServicePageLayoutProps) => {
  return (
    <div>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="mb-6">Why Choose {title}?</h2>
              <p className="text-body-lg text-neutral-taupe mb-8">{description}</p>
              
              <ul className="space-y-3">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <svg className="w-6 h-6 text-primary-green mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-neutral-taupe">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>


          {videoEmbedId && videoEmbedId !== "false" && (
            <div className="relative">
              <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
                <iframe
                  src={`https://www.youtube.com/embed/${videoEmbedId}`}
                  title={`${title} Overview`}
                  frameBorder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
            </div>
          )}
          </div>
        </div>
      </section>

      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <h2 className="text-center mb-12">Key Features</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
                <h3 className="text-xl font-semibold mb-4 text-dark-plum">{feature.title}</h3>
                <p className="text-neutral-taupe">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default ServicePageLayout